export const environment = {
  production: true,
  api: 'https://api.gee.sebrae.acesso.ws/rest',
};
